var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYincang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5L3 13.333",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.458 13.015A6.58 6.58 0 008 13.5c2.157 0 3.702-.905 4.743-2.037 1.029-1.118 1.565-2.455 1.747-3.365L14.51 8l-.02-.098c-.143-.719-.508-1.704-1.162-2.637l-.724.713A6.32 6.32 0 0113.489 8c-.17.756-.632 1.862-1.482 2.787C11.131 11.738 9.843 12.5 8 12.5a5.75 5.75 0 01-1.754-.26l-.788.775zm-.198-1.209a5.32 5.32 0 01-1.267-1.02A6.388 6.388 0 012.511 8a6.388 6.388 0 011.482-2.786C4.869 4.262 6.157 3.5 8 3.5c1.826 0 3.107.747 3.982 1.687l.713-.702C11.655 3.378 10.124 2.5 8 2.5c-2.157 0-3.702.905-4.743 2.036C2.228 5.655 1.692 6.992 1.51 7.902L1.49 8l.02.098c.182.91.718 2.247 1.747 3.365.36.393.782.757 1.268 1.067l.735-.724zM8.012 10.5a2.5 2.5 0 002.487-2.45L8.012 10.5zm2.233-3.602a2.5 2.5 0 10-3.382 3.33l.782-.77a1.5 1.5 0 111.818-1.79l.782-.77z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yincang.2d012799.svg";
export { SvgTongyongYincang as ReactComponent };